import React, { Component } from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, Link } from 'react-router-dom';
import ProjectSettings from './projectmgmt/WhatsAppSettings';
import Telegram from './projectmgmt/Telegram';
import Telephony from './projectmgmt/Telephony';
import Facebook from './projectmgmt/Facebook';
import Reports from './ReportSettings';
import ViewLead from './projectmgmt/ViewLead';
import $ from 'jquery';
import TeamSetting from './projectmgmt/TeamSetting';
import WhatsApp from './projectmgmt/WhatsAppSettings';
import WhatsAppSettings from './projectmgmt/WhatsAppSettings';
import ViewCampaigns from './projectmgmt/ViewCampaigns';
import CustomerChat from './projectmgmt/CustomerChat';
import { toast } from "react-toastify";
class LeftPanel extends Component {

  constructor() {
    super();

    this.state = {
      showOnlyReport: false,
      displayEsc: true,
      showOnlyLeads: false,
    }
  }

  componentDidMount() {
    var leftPanelComp = this;

    (function () {
      var currentPath = window.location.href;


      if (leftPanelComp.state.displayEsc) {
        $("#whatsapp").addClass('activemenu');
      } 
      // else {
      //   $("#").addClass('activemenu');
      // }


      var path = window.origin + "/sales-desk/projectmgmt/";
      var path1 = window.origin + "/sales-desk/projectmgmt";
      if (currentPath == path || currentPath == path1) {
        $("#whatsapp").addClass('activemenu');
      } else if (currentPath.includes('/facebook')) {
        $("#facebook").addClass('activemenu');
      } else if (currentPath.includes('/telegram')) {
        $("#telegram").addClass('activemenu');
      } else if (currentPath.includes('/telephony')) {
        $("#telephony").addClass('activemenu');
      } else if (currentPath.includes('/reports')) {
        $("#reports").addClass('activemenu');
      } else if (currentPath.includes('/settings')) {
        $("#sales-desk-settings").addClass('activemenu');
      } else {
        $("#" + localStorage.getItem("last-used-left-panel-tab")).addClass('activemenu')
      }

      //Onclick Agent Setting tab
      $("#whatsapp")
        .on("click", function () {
          $("#whatsapp,#facebook,#telegram,#telephony,#reports,#sales-desk-settings")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')

          $("#custome-chat,#out-reach-campaign,#manage-template,#configuration")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);
          $("#custome-chat").addClass('active')
        })

      //Onclick Knowledge Management tab
      $("#sales-desk-settings")
        .on("click", function () {
          $("#whatsapp,#facebook,#telegram,#telephony,#reports,#sales-desk-settings")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')

          $("#lead-mapping")
            .removeClass('active');
          localStorage.setItem("last-used-faq-settings-sub-tab", $(this)[0].id);
          $("#lead-mapping").addClass('active')
        })


      $("#facebook")
        .on("click", function () {
          $("#whatsapp,#facebook,#telegram,#telephony,#reports,#sales-desk-settings")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')


        })

      $("#telegram")
        .on("click", function () {
          $("#whatsapp,#facebook,#telegram,#telephony,#reports,#sales-desk-settings")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')

        })

      $("#telephony")
        .on("click", function () {
          $("#whatsapp,#facebook,#telegram,#telephony,#reports,#sales-desk-settings")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')

          $("#lead-mapping")
            .removeClass('active');
          localStorage.setItem("last-used-faq-settings-sub-tab", $(this)[0].id);
          $("#lead-mapping").addClass('active')
        })

      $("#reports")
        .on("click", function () {
          $("#whatsapp,#facebook,#telegram,#telephony,#reports,#sales-desk-settings")
            .removeClass('activemenu');
          localStorage.setItem("last-used-left-panel-tab", $(this)[0].id);
          $(this).addClass('activemenu')
        })



    })();

    var thisController = this;

    setTimeout(() => {
      thisController.fetchRoles();
    }, 300);

    document.addEventListener("projectChanged", function (event) {
      thisController.fetchRoles();
    });
  }

  fetchRoles = () => {

    var localController = this;
    localController.state.showOnlyReport = false;
    localController.setState(localController.state)
    $.ajax({
      url: "/api/project-membership",
      async: false,
      method: 'GET',
      data: {
        projectId: localStorage.getItem('currentProjectId'),
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },

      success: function (res) {
        if (res.success === true) {
          var myUserId = JSON.parse(localStorage.getItem("user_details"))["userId"];
          for (var i = 0; i < res.result.length; i++) {
            if (res.result[i].userId == myUserId && res.result[i].role == "PROJECT_ADMIN") {
              localController.state.showOnlyReport = true;
              localController.setState(localController.state);

            } else if (res.result[i].userId == myUserId && res.result[i].role == "PROJECT_SUPPORT_USER") {
              localController.state.showOnlyLeads = true;
              localController.setState(localController.state);

            }

          }

        }

      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }

    });
  }

  onClickWhatsappTab = () => {
    this.state.displayEsc = true;
    this.setState(this.state);
  }

  onClickOtherTab = () => {
    toast.dismiss();
    setTimeout(() => {
      this.state.displayEsc = false;
      this.setState(this.state);
    }, 200);
  }

  render() {
    return (
      <Router basename={window.contextPath}>
        <div>
          <link rel="stylesheet" href="./plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="./assets/css/adminlte.css" />
          <link rel="stylesheet" href="./assets/css/styles.css" />
          <link rel="stylesheet" href="./assets/css/custom-style.css" />
          <link rel="stylesheet" href="./plugins/iCheck/all.css" />
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link href="assets/css/scrollbar.css" rel="stylesheet" />
          <div className="content-wrapper">
            <div className="left-menu" style={{ marginTop: '0px', position: "absolute", height: "auto" }} >
              <ul id="floatMenu">
                <Link to="/projectmgmt">
                  <a onClick={this.onClickWhatsappTab}>
                    <li id="whatsapp" className="tabs" >
                      <i className="fa flaticon-ui" /><span>Customer Desk</span>
                    </li>
                  </a>
                </Link>
                {/* <Link to="/projectmgmt/facebook">
                  <li id="facebook" className="tabs">
                    <i className="fa flaticon-ui" /><span>Facebook</span>
                  </li>
                </Link>
                <Link to="/projectmgmt/telegram"  >

                  <li id="telegram" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Telegram</span>
                  </li></Link>

                <Link to="/projectmgmt/telephony"  >

                  <li id="telephony" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Telephony</span>
                  </li></Link> */}

                <Link to="/projectmgmt/reports"  >
                  <a onClick={this.onClickOtherTab}>
                    <li id="reports" className="tabs">
                      <i className="fa flaticon-ui" />
                      <span>Reports</span>
                    </li></a></Link>
                <Link to={`/projectmgmt/settings${ this.state.showOnlyLeads ? "/leads" : ""}`}  >

                  <li id="sales-desk-settings" className="tabs">
                    <i className="fa flaticon-ui" />
                    <span>Settings</span>
                  </li></Link>

              </ul>
            </div>
          </div>
          {/* <WhatsAppSettings value={this.state.displayEsc} onClickNotification={this.onClickWhatsappTab} /> */}
          <Switch>
            <Route path="/projectmgmt/settings/out-reach-compaign/manage-campaign/view-campaign-leads" component={ViewCampaigns}></Route>
            <Route path="/projectmgmt/view-leads" component={ViewLead}></Route>
            <Route path={`/projectmgmt/settings${ this.state.showOnlyLeads ? "/leads" : ""}`} component={TeamSetting}></Route>
            <Route path="/projectmgmt/reports" component={Reports}></Route>
            <Route path="/projectmgmt/telephony" component={Telephony}></Route>
            <Route path="/projectmgmt/telegram" component={Telegram}></Route>
            <Route path="/projectmgmt/facebook" component={Facebook}></Route>
            <Route path="/projectmgmt/" component={WhatsAppSettings}></Route>
          </Switch>
        </div>
        {/* <WhatsApp value={this.state.displayEsc} onClickNotification={this.onClickWhatsappTab} /> */}
      </Router>
    );
  }
}
export default LeftPanel;


// WEBPACK FOOTER //
// ./src/sales-desk/LeftPanel.js